import { SET_QUERY } from './mutations';

export const actions = {
    query: function(store, query) {        
        store.commit(SET_QUERY, query);
        store.dispatch('listReq/fetch', query);
    }
};